import {
  ICandidateDashboardShift,
  ICandidateEtab,
  IEtabCategory,
  IQualification,
  ICandidateOfferSalary,
  ICandidateOfferAddress,
  ICandidateOfferScheduleDay,
} from "@core/models";

export const candidateShiftMock = [
  {
    [ICandidateDashboardShift.id]: 35461221032254,
    [ICandidateDashboardShift.startDate]: "2022-09-07",
    [ICandidateDashboardShift.qualification]: {
      [IQualification.qualificationId]: 58,
      [IQualification.qualificationLabel]: "Employé polyvalent",
    },
    [ICandidateDashboardShift.etab]: {
      [ICandidateEtab.name]: "Bar des amis",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café Hôtel Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://extraprd.s3.eu-west-1.amazonaws.com/cc/ab/88/ccab88c473c59b03f612748f02d506f8.jpg"],
    },
    [ICandidateDashboardShift.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardShift.address]: {
      [ICandidateOfferAddress.postalCode]: "75009",
      [ICandidateOfferAddress.city]: "Paris",
      [ICandidateOfferAddress.street]: "16 rue du Vertbois",
    },
    [ICandidateDashboardShift.status]: "coming_soon",
    [ICandidateDashboardShift.shift]: {
      [ICandidateOfferScheduleDay.date]: "2022-09-08",
      [ICandidateOfferScheduleDay.startHour]: 120,
      [ICandidateOfferScheduleDay.endHour]: 200,
      [ICandidateOfferScheduleDay.breakDuration]: 20,
    },
  },
  {
    [ICandidateDashboardShift.id]: 35461221032254,
    [ICandidateDashboardShift.startDate]: "2022-09-07",
    [ICandidateDashboardShift.qualification]: {
      [IQualification.qualificationId]: 58,
      [IQualification.qualificationLabel]: "Employé polyvalent",
    },
    [ICandidateDashboardShift.etab]: {
      [ICandidateEtab.name]: "Bar des amis",
      [ICandidateEtab.category]: {
        [IEtabCategory.id]: 2,
        [IEtabCategory.name]: "Café Hôtel Restaurant",
      },
      [ICandidateEtab.pictures]: ["https://extraprd.s3.eu-west-1.amazonaws.com/cc/ab/88/ccab88c473c59b03f612748f02d506f8.jpg"],
    },
    [ICandidateDashboardShift.salary]: {
      [ICandidateOfferSalary.forecast]: 1250.25,
      [ICandidateOfferSalary.amount]: 15.5,
    },
    [ICandidateDashboardShift.address]: {
      [ICandidateOfferAddress.postalCode]: "75009",
      [ICandidateOfferAddress.city]: "Paris",
      [ICandidateOfferAddress.street]: "16 rue du Vertbois",
    },
    [ICandidateDashboardShift.status]: "in_progress",
    [ICandidateDashboardShift.shift]: {
      [ICandidateOfferScheduleDay.date]: "2022-09-08",
      [ICandidateOfferScheduleDay.startHour]: 120,
      [ICandidateOfferScheduleDay.endHour]: 200,
      [ICandidateOfferScheduleDay.breakDuration]: 70,
    },
  },
];
